import { useMemo } from 'react';
import { UserProfession, UserSubProfession } from '~/enums/UserProfession';
import { ProfessionTypeEnum } from '~/models';
import { TNullable } from '~/types/Nullable';
import { EnumHelper } from '~/utils/EnumHelper';

interface IUseJobProfessionDisplay {
  profession: ProfessionTypeEnum;
  subProfession?: TNullable<string>;
}

export const useJobProfessionDisplay = ({
  profession,
  subProfession,
}: IUseJobProfessionDisplay) => {
  return useMemo(() => {
    const profToDisplay = subProfession || profession;
    if (!profToDisplay) return '';

    const isSubProfession = EnumHelper.getObjectKeys(UserSubProfession).includes(profToDisplay);

    return isSubProfession
      ? UserSubProfession.getName(profToDisplay)
      : UserProfession.getName(profToDisplay);
  }, [profession, subProfession]);
};
